// components/DiscountList.js

import React, { useEffect, useState } from "react";
import {
  getDiscountListService,
  getProductListByModel,
  toggleDiscountActiveService,
  updateProductDiscounts,
} from "../../../services/apiService";
import { Modal, Input, Checkbox, Button, Select } from "antd";
import { showSnackbar } from "../../../comopnents/snackbar";

const DiscountList = () => {
  const [modelNo, setModelNo] = useState("");
  const [products, setProducts] = useState([]);
  const [searched, setSearched] = useState("");
  const [discounts, setDiscounts] = useState([]);
  const [filteredDiscounts, setFilteredDiscounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [updateRows, setUpdateRows] = useState([]);
  // Pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);


  const handleSearch = async (productid, modelNo) => {
    try {
      const res = await getProductListByModel(modelNo);
      console.log(res.data[0]?.Qtydiscounts)
      // setProducts(res.data[0]?.Qtydiscounts);
      setSearched(modelNo);
      openUpdateModal(productid, res?.data)
    } catch (err) {
      console.error(err);
      setProducts([]);
    }
  };

  useEffect(() => {
    loadDiscounts();
  }, []);



  useEffect(() => {

    if (!search) {

      setFilteredDiscounts(discounts);

    } else {

      const lowerSearch = search.toLowerCase();

      const filtered = discounts.filter(

        (item) =>

          item.discountid.toString().includes(lowerSearch) ||

          item.productid.toString().includes(lowerSearch) ||

          item.modelno.toLowerCase().includes(lowerSearch)

      );

      setFilteredDiscounts(filtered);

    }

    setPage(1);

  }, [search, discounts]);



  const loadDiscounts = async () => {

    setLoading(true);

    const data = await getDiscountListService();

    setDiscounts(data);

    setFilteredDiscounts(data);

    setLoading(false);

  };
  /* ================= UPDATE DISCOUNT ================= */
  useEffect(() => {
    if (updateRows.length) {
      setIsUpdateModalOpen(true);
      
    }
  }, [updateRows]);
  const openUpdateModal = (productid, product) => {
    const discounts = product?.[0]?.Qtydiscounts || [];

    const rows = discounts.map((d) => ({
      productid: productid,
      discountid: d.discountid,
      fromqty: d.fromqty,
      toqty: d.toqty,
      discount: d.discount,
      type: d.type || "",
      active: Number(d.active),
    }));

    setUpdateRows(rows);
    setIsUpdateModalOpen(true);
  };

  const handleUpdateRowChange = (index, field, value) => {
    const updated = [...updateRows];
    updated[index][field] = value;
    setUpdateRows(updated);
  };

  const handleUpdateDiscount = async () => {
    try {
      const payload = updateRows.map((row) => ({
        productid: row.productid,
        discountid: row.discountid,
        fromqty: Number(row.fromqty),
        toqty: Number(row.toqty),
        discount: Number(row.discount),
        type: row.type,
        active: Number(row.active),
      }));

      console.log("Final Payload:", payload); // ✅ debug

      await updateProductDiscounts(payload); // 🔥 send array
 await loadDiscounts();
      showSnackbar("success", "Discount updated successfully");
      setIsUpdateModalOpen(false);
    } catch (err) {
      console.error(err);
      showSnackbar("error", "Update failed");
    }
  };



  const handleToggleActive = async (discount) => {
    const newStatus = discount.active === "1" ? 0 : 1;
    setDiscounts((prev) =>
      prev.map((d) =>
        d.discountid === discount.discountid
          ? { ...d, active: newStatus.toString() }
          : d
      )
    );
    try {
      await toggleDiscountActiveService(discount.discountid, newStatus);
    } catch (error) {
      setDiscounts((prev) =>
        prev.map((d) =>
          d.discountid === discount.discountid
            ? { ...d, active: discount.active }
            : d
        )
      );
      console.error("Failed to toggle discount status", error);
    }
  };



  // Pagination Logic

  const totalPages = Math.ceil(

    filteredDiscounts.length / pageSize

  );



  const startIndex = (page - 1) * pageSize;



  const paginatedDiscounts =

    filteredDiscounts.slice(

      startIndex,

      startIndex + pageSize

    );



  if (loading)

    return (

      <p style={{ textAlign: "center" }}>

        Loading discounts...

      </p>

    );



  if (discounts.length === 0)

    return (

      <p style={{ textAlign: "center" }}>

        No discounts available.

      </p>

    );



  const styles = {

    container: {

      padding: "20px",

      fontFamily: "Arial",

    },



    input: {

      marginBottom: "15px",

      padding: "8px",

      width: "250px",

      borderRadius: "4px",

      border: "1px solid #ccc",

    },



    table: {

      width: "100%",

      borderCollapse: "collapse",

    },



    th: {

      border: "1px solid #ddd",

      padding: "8px",

      backgroundColor: "#cdd1d3",

    },



    td: {

      border: "1px solid #ddd",

      padding: "8px",

      textAlign: "center,",
      color: "black"

    },

  };



  return (

    <div style={styles.container}>



      <h3>Discount List</h3>



      <input

        style={styles.input}

        type="text"

        placeholder="Search DiscountID, ProductID, ModelNo"

        value={search}

        onChange={(e) => setSearch(e.target.value)}

      />



      <table style={styles.table}>

        <thead>

          <tr>

            <th style={styles.th}>Discount ID</th>

            <th style={styles.th}>Product ID</th>

            <th style={styles.th}>Model No</th>

            <th style={styles.th}>From Qty</th>

            <th style={styles.th}>To Qty</th>

            <th style={styles.th}>Discount %</th>

            <th style={styles.th}>Type</th>

            <th style={styles.th}>Active</th>

            <th style={styles.th}>Date</th>
            <th style={styles.th}>Action</th>

          </tr>

        </thead>



        <tbody>



          {paginatedDiscounts.map((item) => (

            <tr key={item.discountid}>



              <td style={styles.td}>

                {item.discountid}

              </td>



              <td style={styles.td}>

                {item.productid}

              </td>



              <td style={styles.td}>

                {item.modelno}

              </td>



              <td style={styles.td}>

                {item.fromqty}

              </td>



              <td style={styles.td}>

                {item.toqty}

              </td>



              <td style={styles.td}>

                {item.discount}

              </td>

              <td style={styles.td}>

                {item.type || "--"}

              </td>
              <td style={styles.td}>
                <label className="switch">

                  <input

                    type="checkbox"

                    checked={item.active === "1"}

                    onChange={() =>

                      handleToggleActive(item)

                    }

                  />
                  <span className="slider"></span>
                </label>

              </td>
              <td style={styles.td}>

                {item.date

                  ? new Date(item.date)

                    .toLocaleDateString()

                  : "--"}

              </td>
              <td>
                <button style={{
                  backgroundColor: "#006098",
                  padding: "6px 12px",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer"
                }} onClick={() => handleSearch(item.productid, item.modelno)}>
                  Update
                </button>
              </td>
            </tr>

          ))}



        </tbody>

      </table>



      {/* Pagination */}



      <div className="pagination">



        <div style={{ color: "black" }}>

          Items per page:


          <select

            value={pageSize}

            onChange={(e) => {

              setPageSize(Number(e.target.value));

              setPage(1);

            }}

          >

            {[5, 10, 20, 50].map((n) => (

              <option key={n} value={n}>

                {n}

              </option>

            ))}



          </select>



        </div>



        <div>



          <button

            disabled={page === 1}

            onClick={() => setPage(page - 1)}

          >

            Previous

          </button>



          <span style={{ color: "black" }}>

            {page} / {totalPages || 1}

          </span>



          <button

            disabled={

              page === totalPages ||

              totalPages === 0

            }

            onClick={() => setPage(page + 1)}

          >

            Next

          </button>
          <Modal
            title="Update Discount"
            open={isUpdateModalOpen}
            onCancel={() => setIsUpdateModalOpen(false)}
            footer={null}  // custom buttons
          > {updateRows?.map((row, i) => (
            <div key={i} style={{ display: "flex", gap: 10, marginBottom: 10 }}>
              <Input value={row.discountid} disabled style={{ width: 100 }} />

              <Input
                value={row.fromqty}
                onChange={(e) =>
                  handleUpdateRowChange(i, "fromqty", e.target.value)
                }
                placeholder="From"
              />

              <Input
                value={row.toqty}
                onChange={(e) =>
                  handleUpdateRowChange(i, "toqty", e.target.value)
                }
                placeholder="To"
              />

              <Input
                value={row.discount}
                onChange={(e) =>
                  handleUpdateRowChange(i, "discount", e.target.value)
                }
                placeholder="Discount"
              />

              <Select
                placeholder="Type"
                value={row.type || undefined}
                onChange={(val) => handleUpdateRowChange(i, "type", val)}
                style={{ width: 100 }}
                options={[
                  { value: "piece", label: "Piece" },
                  { value: "pack", label: "Pack" },
                  { value: "cart", label: "Cart" },
                  { value: "extra1", label: "Ext 1" },
                  { value: "extra2", label: "Ext 2" },
                  { value: "extra3", label: "Ext 3" },
                ]}
              />

              <Checkbox
                checked={row.active === 1 || row.active === "1"}
                onChange={(e) =>
                  handleUpdateRowChange(i, "active", e.target.checked ? 1 : 0)
                }
              >
                Active
              </Checkbox>
            </div>
          ))}

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <Button onClick={() => setIsUpdateModalOpen(false)}>Cancel</Button>

              <Button type="primary" onClick={handleUpdateDiscount}>
                Update
              </Button>
            </div></Modal>



        </div>



      </div>



      <style>
        {`
.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ccc;
  border-radius: 24px;
  transition: 0.3s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: white;
  border-radius: 50%;
  transition: 0.3s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

input:checked + .slider {
  background: #4CAF50;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

button {
  padding: 6px 12px;
  margin: 5px;
  cursor: pointer;
}

select {
  padding: 5px;
  margin-left: 5px;
}
`}
      </style>



    </div>

  );

};



export default DiscountList;